export default __webpack_public_path__ + "static/media/button-info-hover.46340da2.svg";